import { AssessmentCriterion } from "../components/AssessmentCriteriaSelection";

const formatAssessmentCriterion = (assessmentCriterion: AssessmentCriterion) =>
  assessmentCriterion.criterion +
  (assessmentCriterion.details ? " » " : "") +
  assessmentCriterion.details;

export default formatAssessmentCriterion;
